import {
	SERVICE_PROVIDER_TECHNICIAN,
	SERVICE_PROVIDER_MANAGER,
	PORTAL_ADMINISTRATOR,
	DISPATCHER,
	IMBERA_TECHNICIAN,
	SPARE_PARTS_IMBERA_USA,
	SALES_MANAGER,
	SALES_REPRESENTATIVE_MANAGER,
	CUSTOMER_MANAGER,
	CUSTOMER_TECHNICIAN,
	VISUALIZER
} from '../../../resources/RolesEnum'

const FilterConfig = [
	{
		title: 'STATUS',
		key: 'status',
		type: 'select',
		nameFilterUrl: 'statusFilter',
		isVisibleSearch: false,
		roles: [
			SERVICE_PROVIDER_TECHNICIAN,
			SERVICE_PROVIDER_MANAGER,
			PORTAL_ADMINISTRATOR,
			DISPATCHER,
			IMBERA_TECHNICIAN,
			SPARE_PARTS_IMBERA_USA,
			SALES_MANAGER,
			SALES_REPRESENTATIVE_MANAGER,
			CUSTOMER_MANAGER,
			CUSTOMER_TECHNICIAN,
			VISUALIZER
		]
	},
	{
		title: 'Sales rep',
		key: 'salesRep',
		type: 'select',
		nameFilterUrl: 'representativesFilter',
		isVisibleSearch: true,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Provider',
		key: 'provider',
		type: 'select',
		nameFilterUrl: 'serviceProviderFilter',
		isVisibleSearch: true,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Customer',
		key: 'customer',
		type: 'select',
		nameFilterUrl: 'retailersFilter',
		isVisibleSearch: true,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Dispatcher',
		key: 'dispatcher',
		type: 'select',
		nameFilterUrl: 'dispatcherFilter',
		isVisibleSearch: true,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Tech assigned',
		key: 'techAssigned',
		type: 'select',
		nameFilterUrl: 'teachAssignedFilter',
		isVisibleSearch: true,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Work Process Status',
		key: 'workProcessStatus',
		type: 'select',
		nameFilterUrl: 'workProcessStatusFilter',
		isVisibleSearch: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Priority',
		key: 'priority',
		type: 'select',
		nameFilterUrl: 'priorityFilter',
		isVisibleSearch: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'State',
		key: 'state',
		type: 'text',
		nameFilterUrl: 'stateFilter',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'ZIP Code',
		key: 'zipCode',
		type: 'text',
		nameFilterUrl: 'zipCodeFilter',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Site Contact Name',
		key: 'siteContactName',
		type: 'text',
		nameFilterUrl: 'siteContactNameFilter',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Phone Number',
		key: 'phoneNumber',
		type: 'text',
		nameFilterUrl: 'phoneNumberFilter',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Dispatch Call Back Date',
		key: 'dispatchStatusDate',
		type: 'dateRange',
		startDateParam: 'dispatchStatusStartDate',
		endDateParam: 'dispatchStatusEndDate',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Dispatch Phase',
		key: 'dispatchStatus',
		type: 'select',
		nameFilterUrl: 'dispatchStatusFilter',
		isVisibleSearch: true,
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	},
	{
		title: 'Network Days',
		key: 'networkDays',
		type: 'text',
		nameFilterUrl: 'networkDaysFilter',
		visible: false,
		roles: [PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN, VISUALIZER]
	}
]
export default FilterConfig
